import classNames from 'classnames'
import * as dateFns from 'date-fns'
import React from 'react'

import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../components/Table'
import { shortFormatNumber } from '../../util'
import { WidgetHeader } from '../earnings-common/WidgetHeader'
import { HISTORY_COLUMNS } from './constants'
import { Dividend } from './types'

interface Props {
  dividends: Dividend[]
}

export function DividendsPayoutHistory({ dividends }: Props) {
  return (
    <div className="mt-4">
      <WidgetHeader>Dividend payout history</WidgetHeader>
      <Table className="financials-table table-fixed leading-4 [overflow-anchor:none]">
        <TableHead>
          {HISTORY_COLUMNS.map((column) => (
            <TableHeader key={column.id} align={column.align} className="px-3.5">
              {column.name}
            </TableHeader>
          ))}
          {/* Spacer header col */}
          <TableCell />
        </TableHead>
        <TableBody>
          {dividends.map((dividend, index, arr) => (
            <TableRow
              key={dividend.Exdate}
              className={classNames('is-top-border hoverable-section !cursor-default', {
                'is-top-radius': index === 0,
                'is-bottom-border is-bottom-radius': index === arr.length - 1,
              })}
            >
              {HISTORY_COLUMNS.map((column) => (
                <TableCell key={column.id} align={column.align} hasLeading={false} className="px-3.5 py-1">
                  {column.id === 'Exdate'
                    ? dateFns.format(dateFns.parseISO(dividend[column.id]), 'MMM dd, yyy')
                    : shortFormatNumber(dividend[column.id], { fractions: 2 })}
                </TableCell>
              ))}

              {/* Spacer col */}
              <TableCell />
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  )
}
